<!--
キャラページ全体
-->

<template>
    <div class="chara-content">

        <ul class="c-tabmenu c-tabmenu_max-200">
            <li class="c-tabmenu__item">
                <router-link :to="{name:'story', params:{story:'washio'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Washio Sumi Chapter</span>
                </router-link>
            </li>
            <li class="c-tabmenu__item">
                <router-link :to="{name:'story', params:{story:'yusha'}}" class="c-tabmenu__link">
                    <span class="c-tabmenu__text">Hero Chapter</span>
                </router-link>
            </li>
        </ul>

        <transition name="chara-select">
            <ul class="chara-select" v-show="!is_change_story">
                <chara-thumb v-for="(chara, index) in chara_list" :story="story" :id="chara.id" :thumb="chara.thumb" :key="index"></chara-thumb>
            </ul>
        </transition>

        <chara-detail></chara-detail>
    </div>
</template>

<script>
// キャラ用データ
import chara_data from '../../js/page/chara/chara_data';
// サムネイルコンポーネント
import CharaThumbCompo from './chara-thumb.vue';
// 詳細コンポーネント
import CharaDetailCompo from './chara-detail.vue';

const default_story = 'washio';
const default_chara = {
    washio: 'sumi',
    yusha: 'yuna'
};


export default {
    data() {
        return {
            story: null,
            is_change_story: true
        };
    },
    components: {
        'chara-thumb': CharaThumbCompo,
        'chara-detail': CharaDetailCompo
    },
    computed: {
        chara_list() {
            return chara_data.get_data('chara_list')[this.story];
        },
    },
    watch: {
        // 物語が変更されたらキャラ選択も変更する
        $route: 'change_story'
    },
    created() {
        // 物語か、キャラが指定されていない
        if (!this.$route.params.story) {
            // 物語が指定されていない場合、キャラも一緒に指定する
            this.$router.push(`/${default_story}/${default_chara[default_story]}`);

        } else if (!this.$route.params.id) {
            // 物語のデフォルトキャラを設定する
            this.$router.push(`/${this.story}/${default_chara[this.story]}`);
        }
        this.change_story();
    },
    methods: {
        /**
        * 物語が変更された
        */
        change_story() {
            // 物語に変更がなければ無視する
            if (this.story === this.$route.params.story) {
                return;
            }

            this.is_change_story = true;

            setTimeout(() => {
                this.story = this.$route.params.story;
                this.is_change_story = false;

                if (!this.$route.params.id) {
                    // 物語のデフォルトキャラを設定する
                    this.$router.push(`/${this.story}/${default_chara[this.story]}`);
                }
            }, 400);
        }
    }
};
</script>



// WEBPACK FOOTER //
// chara-content.vue?6c56afae